<template>
  <div :class="['good-container', fromPage == 'fitPage' ? 'fitPage' : '']">
    <!-- {{ curentTotal }} -->
 
    <div class="goods-list">
  
      <div
        :class="['goods-item', good.imgLoadedStyle ? 'imgloaded' : '']"
        v-for="(good, index) in newArray"
        :key="index"

        v-show="good.imgLoaded&&!(sellout&&sellout=='HIDE'&&good.stock==0)"
        @mouseenter="showActive(index, 'over')"
        @mouseleave="showActive(null, 'leave')"
        @touchstart="touchstart($event,index,'over')"
        @touchend="touchEnd($event,null,'leave')"
      >

       <div class="linkwrap">
         <a target="_self" :href="hrefhost+'/shopping/'+good.friendlyUrl" tabindex="-1" ></a>
       </div>
       <div  v-if="(parseInt(index/10)%2==1 && (index%10)==3)">
         <div v-is-intersecting.instant="viewHandler" :index="index"></div>
       </div>
        <div :class="['all-cover', good.imgLoaded ? 'loaded' : '']"></div>
        <div
          :class="['save-btn', index == activeIndex ? 'show-save' : '']"
          v-if="fromPage != 'fitPage'"
        >
          <button
            :class="['btns', index == activeIndex ? 'show-save' : '']"
            v-on:click.stop="addWish(good.id, good)"
          >
            保存
          </button>
        </div>
        <div class="auto-height">
          
          <div class="product-sign" v-if="sellout=='DISPLAY'&&good.stock==0&&(!(index == activeIndex))">
            {{ysjsshow=='JQQD'?'... 敬请期待 ...':'... 暂时售罄 ...'}}
          </div>
          <div
            class="product-sign"
            v-if="(good.signs && good.signs.length > 0)&&!(sellout=='DISPLAY'&&good.stock==0) && good.imgLoadedStyle&&(!(index == activeIndex))"
          >
            {{ good.signs[0].name }}
          </div>
          <div class="covers"></div>
          <img
            :class="['over-img']"
            itemprop="image"
            :id="['good-img' + index + componentIndex]"
            :src="
              good.imgLoaded
                ? good.imageList[0].originalUrl
                : 'https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202111/6a289b22ba0dd1546bab1b2f4b0c623a.png'
            "
            :title="good.name"
            :alt="good.name"
            data-fadein
            style="image-rendering: -webkit-optimize-contrast"
          />

          <img
            v-if="good.imgLoaded"
            :class="[
              'over-img base-img',
              activeIndex == index ? 'show-save' : '',
            ]"
            :src="
              changecolorimg
                ? changecolorimg
                : good.imageList[1]
                ? good.imageList[1].originalUrl
                : good.imageList[0].originalUrl
            "
            :title="good.name"
            :alt="good.name"
          />
          <!-- pc端颜色 Start-->
          <div :class="['other-color pc', 'show-save']" @mouseenter.stop="stopmaopao()" v-if="colorList.length > 1 && index == activeIndex">
            <div class="colorstext">更多颜色</div>
            <div class="colors">
              <div class="color-item" v-for="(color, sindex) in colorList" :key="sindex" style="position: relative;">
                <img
                  class="color"
                  v-if="color.colorImg"
                
                  :src="color.colorImg"
                  :title="color.colorText"
                />
                <div class="linkwrap"   @mouseenter="showImg(sindex)"
                  @mouseleave="showImgLeave(null)"  
               >
                  
                  <a   :href="hrefhost+'/shopping/'+color.friendlyUrl" tabindex="-1" ></a>
                </div>
            
            
            </div>
          </div>
        </div>
          <!-- pc端颜色 End -->
          <!-- mob端颜色 Start -->
         <div  @touchstart.stop="stopmaopao()" :class="['other-color mob', 'show-save']" @mouseenter.stop="stopmaopao()" v-if="colorList.length > 1 && index == activeIndex">
           <div class="flex">
            <div class="colorstext">更多颜色</div>
            <div class="colors">
              <div
                class="color-item"
                v-for="(color, sindex) in colorList"
                :key="sindex"
                @click.stop="goPDP_color(color.friendlyUrl)"
              >
                <img
                  class="color"
                  v-if="color.colorImg"
                  @mouseenter="showImg(sindex)"
                  @mouseleave="showImgLeave(null)"
                  @touchstart.stop="touchstartimg($event,sindex,'over')"
                  @touchend.stop="touchEndimg($event,null,'leave')"
                  :src="color.colorImg"
                />
              </div>
            </div>
            </div>
          </div>
          <!-- mob端颜色 End -->
        </div>
        <div
          class="goods-name"
          @mouseover="showActive(index, 'over')"
          @mouseleave="showActive(null, 'leave')"
        >
            
          <div
            class="product-sign-mb"
            v-if="good.signs && good.signs.length > 0"
          >
            {{ good.signs[0].name }}
          </div>
          <div class="name">{{ good.name }}</div>
          <template
            v-if="good.discountPrice != '0' && good.discountPrice != undefined"
          >
            <div class="originprice">
              ¥{{ $utils.toThousands(good.leastPrice) }}
            </div>
            <div class="currprice">
              ¥{{ $utils.toThousands(good.discountPrice) }}
            </div>
          </template>
          <template v-else>
            <div class="currprice">
              ¥{{ $utils.toThousands(good.leastPrice) }}
              <span v-if="good.leastPrice.indexOf('起') != -1 ? true : false"
                >起</span
              >
            </div>
          </template>
        </div>
      </div>

  </div>
</div>
</template>

<script>
export default {
  name: "Goods",
  data() {
    return {
      curProduct: {},
      reloadList: [],
      newArray: [],
      API: this.$store.state.API,
      colorList: [],
      ossSuffix: "",
      ossSuffixOrigin: "",
      changecolorimg: "",
      changecolorimgIndex: -1,
      showUser: false,
      activeIndex: null,
      dataIndex:0,
      maxIndex:20,
      isLoading:false,
      showIndexMap:{},
      hrefhost:window.location.protocol+'//'+window.location.host
    };
  },
  inject: ["reload"],
  props: {
    curentTotal: {
      type: Number,
      default: 0,
    },
    soldOut: {
      type: Number,
      default: 0,
    },
    ysjsshow:{
      type:String
    },
    sellout:{
      type:String
    },
    limit: {
      type: Number,
      default: 10000,
    },
    componentIndex: {
      type: Number,
      default: 0,
    },
    fromPage: {
      type: String,
      default: "",
    },
    receiveData: {
      type: null,
      observer: function (newVal, oldVal) {
        console.log(newVal,'自定义页面数据')
        var that = this;
      },
    },
  },
  computed: {
    colorText() {
      if (this.changecolorimgIndex != -1) {
        return this.colorList[this.changecolorimgIndex].colorText;
      } else {
        let obj = null;
        for (let color of this.colorList) {
          if (color.productId == this.curProduct.id) {
            obj = color;
          }
        }
        return obj.colorText;
      }
    },
  },
  components: {},
  watch: {
    receiveData(newVal, oldVal) {
      if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
        // this.reload();
        this.$store.commit("setValue", ["hasChangUrl", false]); //是否需要终止上一次数据的循环
        this.newArray = this.lastData(); //筛选后的数据
        //需要预加载的数据
        var tempdata = this.receiveData.slice(0, this.limit); //分割的数据所有数据源
        var start = tempdata.length - this.newArray.length;
        // console.log("start:",this.curentTotal-start)
        this.loadImages(0);
        // this.reLoadImage();
      }

      if (this.$route.name == "404") {
        this.gaViewItem();
        this.gaViewItemList();
      }
    },
  },
  created() {
    this.getLoginStatus();
   
    //定时清除缓存数据
    // setTimeout(() => {
    //   window.localStorage.removeItem("browseList");
    //   console.log("定时清除缓存数据");
    // }, 3000); //1800000
  },
  mounted() {
    this.newArray = this.lastData();
    this.$store.commit("setValue", ["hasChangUrl", false]); //是否需要终止上一次数据的循环

    this.ossSuffix = "?x-oss-process=style/tb_plp_w_1200";
    this.ossSuffixOrigin = "?x-oss-process=style/tb_plp_w_600_origin";

    // console.log("加载数组",this.newArray)
    //需要预加载的数据
    // this.reLoadImage();
    this.loadImages(0);

    if (this.$route.name != "404") {
      this.gaViewItem();
      this.gaViewItemList();
    }
  },
  methods: {
 
    fmtColorImg(imgsec) {
      let ossSuffix = "?x-oss-process=style/tb_general_color_w_48";
      imgsec = this.$utils.replaceImage(imgsec);
      let flag = this.$utils.checkIsUpdatetoWebp(this, imgsec);
      if (flag) {
        imgsec = imgsec + ossSuffix;
      }

      return imgsec;
    },
    viewHandler(target) {
      //页面滚动到第13个商品的时候，执行另外一轮加载另外20个商品的操作
      let index = parseInt(target.getAttribute("index"));
      this.loadAndShowMoreImg(index);
    },
    loadAndShowMoreImg(index) {
      if (this.showIndexMap[index] != 1) {
        let start = parseInt(index / 10) * 10 + 10;
        this.showIndexMap[index] = 1;
        let end = parseInt(index / 10) * 10 + 30;
        this.maxIndex = end;
        // console.log("ttt",index,start,end,this.dataIndex)
        if (!this.isLoading) {
          this.loadImages(this.dataIndex + 1);
          return;
        }
      }
    },
    reLoadImage() {
      // var temp = JSON.stringify(this.newArray);
      // this.reloadList = JSON.parse(temp).splice(
      //   this.curentTotal,
      //   this.newArray.length
      // );
      // this.isSupportWebp = window.localStorage.getItem("isSupportWebp");
      // // this.ossSuffix = this.$store.state.ossSuffix+"_plp_w_600";
      // for (var i = 0; i < this.reloadList.length; i++) {
      //   if (i >= 10) {
      //     return;
      //   }
      //   var img = new Image();
      //   //检测是否支持webp格式
      //   var imgsec = this.reloadList[i].imageList[0].originalUrl;
      //   if(imgsec.indexOf('x-oss-process')!=-1){
      //     img.src = imgsec;
      //     return;
      //   }
      //   let flag = this.$utils.checkIsUpdatetoWebp(this, imgsec);
      //   if (flag) {
      //     img.src = this.newArray[i].imageList[0].originalUrl + this.ossSuffix;
      //   } else {
      //     img.src =
      //       this.newArray[i].imageList[0].originalUrl + this.ossSuffixOrigin;
      //   }
      // }
    },
    loadImages(i) {
      // console.log("loadImages: ",i);

      var that = this;
      if (i > that.maxIndex) {
        return;
      }
      if (i >= that.newArray.length - 1) {
        that.$emit("loadFinish");
      }
      var img = new Image();
      this.isLoading = true;

      img.onload = function () {
        // console.log("onload: " + i, "time: " + new Date(), "i shi:", 'id:',that.newArray[i].id);
        //检测是否支持webp格式
        //  console.log("onload: ",i);

        let imgsec = that.newArray[i].imageList[0].originalUrl;
        let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
        let ossSuffix = that.ossSuffixOrigin;
        if (flag) {
          ossSuffix = that.ossSuffix;
        }
        var imageList = that.newArray[i].imageList;
        if (imageList[0].originalUrl.indexOf("x-oss-process") == -1) {
          imageList[0].originalUrl = imageList[0].originalUrl + ossSuffix;
        }

        if (imageList.length > 1) {
          if (imageList[1].originalUrl.indexOf("x-oss-process") == -1) {
            imageList[1].originalUrl = imageList[1].originalUrl + ossSuffix;
          }
        }
        that.$set(that.newArray[i], `imageList`, imageList);
        that.$set(that.newArray[i], `imgLoaded`, true);
        if (i == 0) {
          setTimeout(() => {
            that.$set(that.newArray[i], `imgLoadedStyle`, true);
          }, 10);
        } else {
          setTimeout(() => {
            that.$set(that.newArray[i], `imgLoadedStyle`, true);
          }, 80);
        }

        that.dataIndex = i;
        that.isLoading = false;
        if (i == 0) {
          that.$emit("loadingFun");
        }
        // if (i == that.newArray.length-1){
        //    that.$emit("loadFinish");
        // }
        let count = i + 1;
        if (count < that.newArray.length) {
          that.loadImages(count);
        }
      };
      img.onerror = function () {
        that.$set(that.newArray[i], `imgLoaded`, true);
        if (i == 0) {
          that.$emit("loadingFun");
        }
        let count = i + 1;
        if (count < that.newArray.length) {
          that.loadImages(count);
        }
      };

      let imgsec = that.newArray[i].imageList[0].originalUrl;

      if (imgsec.indexOf("x-oss-process") != -1) {
        img.src = imgsec;
        return;
      }
      let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
      if (flag) {
        img.src = imgsec + this.ossSuffix;
      } else {
        img.src = imgsec + this.ossSuffixOrigin;
      }
    },
    stopmaopao() {
      console.log();
    },
    //图片
    async loadImages1() {
      // this.preLoadingImage();
      for (var i = 0; i < this.newArray.length; i++) {
        if (this.$store.state.hasChangUrl) {
          break;
        }
        await this.loadImg(i); //执行完成之后才走下一步；
      }
    },
    async loadImg(i) {
      var that = this;
      var img = new Image();
      img.src = that.newArray[i].imageList[0].originalUrl;
      return new Promise(function (resolve, reject) {
        img.onload = function () {
          that.$set(that.newArray[i], `imgLoaded`, true);
          // console.log("imgLoaded:" + i);
          if (i == 0) {
            that.$emit("loadingFun");
          }
          resolve(i + 1);
        };
      });
    },
    lastData() {
      var soldOut = this.$store.state.soldOut;
      var tempdata = this.receiveData.slice(0, this.limit);
      for (let data of tempdata) {
        for (let img of data.imageList) {
          img.originalUrl = this.$utils.replaceImage(img.originalUrl);
        }
      }

      if (soldOut == 0) {
        return tempdata.filter(function (item) {
          return item.stock >= 0; //返回isShow=true的项，添加到activeUsers数组
        });
      } else {
        return tempdata;
      }
    },
    //view_item的ga埋点
    gaViewItem() {
      if (this.newArray.length != 0) {
        let gaUrl = "";
        if (this.$route.name == "custom") {
          gaUrl = "custom_" + this.$store.state.pageTitle;
        } else if (this.$route.name == "404") {
          gaUrl = "404";
        } else if (this.$route.name == "home") {
          gaUrl = "hp_displaybanner";
        } else {
          return;
        }
        this.$gaAction.view_item(this.newArray, gaUrl);
      }
    },

    //view_item_list埋点
    gaViewItemList() {
      if (this.newArray.length != 0) {
        let gaUrl = "";
        if (this.$route.name == "sets") {
          gaUrl = "plp_" + this.$store.state.pageTitle;
        } else if (this.$route.name == "searchList") {
          gaUrl = "search_results";
        } else {
          return;
        }
        let gaData = [];
        for (let i in this.newArray) {
          gaData.push(this.newArray[i]);
        }
        this.$gaAction.view_item_list(gaData, gaUrl);
      }
    },
    getLoginStatus() {
      const that = this;
      return new Promise((resolve, reject) => {
        this.hasLogin = window.localStorage.getItem("token") ? false : true;
        resolve(this.hasLogin);
      });
    },
    //GA add_to_wishlist埋点
    gaAddToWishList(gaData) {
      let gaUrl = "123";
      if (this.$route.name == "sets") {
        gaUrl = "custom_sets";
      } else {
        gaUrl = "plp_";
      }
      this.$gaAction.add_to_wishlist(gaData, gaUrl);
    },
    //加入购物车
    async addWish(goodId, goodInfo) {
      this.gaAddToWishList(goodInfo);
      let hasLogin = await this.getLoginStatus();
      if (hasLogin) {
        this.$store.commit("setValue", ["showLoginPop", true]);
        return false;
      }

      let url = this.API.my.addWish;
      let params = {
        merchantId: this.$store.state.storeId,
        openId: this.$store.state.openId || this.$store.state.userId,
        productId: goodId,
        skuId: "",
        skuImageValue: "",
        skuSpecValue1: "",
        skuSpecValue2: "",
        skuNu: 1,
        flag: 0, //0：收藏，1：取消收藏
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then((res) => {
          if (res.data.result) {
            let state_3 = this.$store.state.RefreshLoveList;
            let state_4 = this.$store.state.loveListFalg;
            this.$store.commit("showLoveListPop", !state_4);
            this.$store.commit("RefreshLoveList", !state_3);
            return false;
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch((err) => {});
    },
    goPDP_color(id) {
      this.activeIndex=-1;
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: id,
        },
      });
    
    },
    goPDP(id, good, index) {
      this.gaSelectContent(good, index);
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: id,
        },
      });
    },

    //GA select_content埋点
    gaSelectContent(good, index) {
      console.log(this.$route.name);
      if (this.$route.name == "404") {
        this.$set(good, "list_name", "404");
      } else if (this.$route.name == "searchList") {
        this.$set(good, "list_name", "search_results");
      } else if (this.$route.name == "custom") {
        this.$set(good, "list_name", "custom_" + this.$store.state.pageTitle);
      } else if (this.$route.name == "sets") {
        this.$set(good, "list_name", "plp_" + this.$store.state.pageTitle);
      } else if (this.$route.name == "home") {
        this.$set(good, "list_name", "hp_displaybanner");
      } else {
        return;
      }
      this.$set(good, "list_position", index);
      this.$gaAction.select_content(good);
    },
    touchstartimg(e,index,type){
      e.stopPropagation();
   
      this.changecolorimgIndex = index;
      setTimeout(() => {
        this.changecolorimg = this.colorList[index].firImageUrl;
      }, 0);
    },
    touchEndimg(e,index,type){
      //  this.changecolorimg = "";
      //  this.changecolorimgIndex = -1;
    },
    showImg(index) {
   
      this.changecolorimgIndex = index;
      setTimeout(() => {
        this.changecolorimg = this.colorList[index].firImageUrl;
      }, 0);
    },
    showImgLeave() {
      this.changecolorimg = "";
      this.changecolorimgIndex = -1;
    },
    touchstart(e,index,type){
     //经鼠标经过的数据保存在缓存中
      if (type == "over") {
        if (!this.newArray[index].imgLoaded) {
          return false;
        } else {
          this.curProduct = this.newArray[index];
          if(this.activeIndex==index){
            this.activeIndex = -1;
          }else{
            this.activeIndex = index
          }
         
          this.setLocalStorage(index);
        }
        
      } else {
     
        this.activeIndex = index;
        this.colorList = [];
      }
    },
    touchEnd(e,index,type){
        // this.activeIndex = index;
        // this.colorList = [];
    },
    showActive(index, type) {
      //经鼠标经过的数据保存在缓存中
      if (type == "over") {
        if (!this.newArray[index].imgLoaded) {
          return false;
        } else {
          this.curProduct = this.newArray[index];
          this.activeIndex = index;
          this.setLocalStorage(index);
        }
      } else {
        this.activeIndex = index;
        this.colorList = [];
        this.changecolorimg='';
        console.log('water')
      }
    },
    getColorImages(baseId) {
      let url =
        this.$store.state.API.pdp.getColorImages +
        "?merchantId=" +
        this.$store.state.storeId +
        "&baseId=" +
        baseId;
      this.$http.get(url).then((res) => {
        if (res.data.result) {
          let returnData = res.data.returnData || [];
          let dtoList = [];
          let result = { productId: baseId, dtoList: [] };
          if (returnData.length > 0) {
            if (returnData[0].self && !returnData[0].url) {
              dtoList = [];
            } else {
              returnData.forEach((item, index) => {
                if (item.url) {
                  dtoList.push({
                    colorImg: item.url,
                    friendlyUrl: item.friendlyUrl,
                    productId: item.id,
                    self: item.self,
                    originalUrls: [item.secImageUrl],
                    firImageUrl: item.firImageUrl,
                    secImageUrl: item.secImageUrl,
                    colorText: "",
                    baseId: item.baseId,
                  });
                }
              });
            }

            result.dtoList = dtoList;
            // 把颜色图片数据缓存下来
            let newcolorListcache = result.dtoList;
            if (newcolorListcache.length >= 2) {
              newcolorListcache.forEach((item, index) => {
                let image = new Image();
                image.src = item.colorImg;
                image.onload = () => {
                  console.log("颜色缓存成功");
                };
              });
            }

            this.colorList = newcolorListcache;
            //
            if (result.dtoList) {
              var localData = JSON.parse(
                window.localStorage.getItem("browseList")
              );
              var browseList = [];
              if (localData) {
                browseList = localData.data || [];
              }
              browseList.push(result);
              window.localStorage.setItem(
                "browseList",
                JSON.stringify({
                  data: browseList,
                  expiration: new Date().getTime() + 1800000,
                })
              );
            }
          }
        }
      });
    },
    async getMixByProductId(productId) {
      var that = this;
      let url = this.$store.state.API.plp.getMixByProductId;
      this.$http.get(url + "?productId=" + productId, {}).then((res) => {
        if (res.status == 200 && res.data.result) {
          var result = res.data.returnData;
          this.colorList = result.dtoList;
          if (result.dtoList) {
            var localData = JSON.parse(
              window.localStorage.getItem("browseList")
            );
            var browseList = [];
            if (localData) {
              browseList = localData.data || [];
            }
            browseList.push(result);
            window.localStorage.setItem(
              "browseList",
              JSON.stringify({
                data: browseList,
                expiration: new Date().getTime() + 1800000,
              })
            );
          }
        } else {
        }
      });
    },
    setLocalStorage(index) {
      var localData = JSON.parse(window.localStorage.getItem("browseList"));
      var time = null;
      var browseList = [];
      if (localData) {
        time = localData.expiration;
        browseList = localData.data || [];
      }
      var goodId = this.newArray[index].id;

      var flag = true;
      for (var i = 0; i < browseList.length; i++) {
        if (browseList[i].productId == goodId) {
          this.colorList = browseList[i].dtoList;
          flag = false;
        }
      }
      // new Date().getTime() - time > exp;
      if (new Date().getTime() > time && time) {
        // 这里开始执行超时的代码
        delete localStorage.browseList;
        // this.getMixByProductId(goodId);
        this.getColorImages(goodId);
      } else if (flag) {
        // this.getMixByProductId(goodId);
        this.getColorImages(goodId);
      }

      // if (flag) {
      //   //保存并且取调取接口进行查询
      //   this.getMixByProductId(goodId);
      // }

      // if (JSON.stringify(browseList).indexOf(JSON.stringify(goodId)) == -1) {
      //   //保存并且取调取接口进行查询
      //   this.getMixByProductId(goodId);
      // } else {
      //   for (var m = 0; m < browseList.length; m++) {
      //     if (browseList[m].productId == goodId) {
      //       this.colorList = browseList[m].dtoList;
      //       break;
      //     }
      //   }
      //   //存在就直接取缓存里面的数据进行显示
      // }
    },
    getSingelGoods() {},
  },
};
</script>
<style lang="less" scoped>
.pc{
  display: flex!important;
}
.mob{
  display: none!important;
}
.good-container {
  margin-bottom: 2.5rem;
  padding-top: 2rem;
  &.fitPage {
    .goods-item {
      width: 22% !important;
      margin-left: 0 !important;
      margin-right: 4% !important;
      &:nth-of-type(4n) {
        margin-right: 0 !important;
      }
    }
  }
  .goods-list {
    display: flex;
    flex-flow: row wrap;
    .goods-item {
      width: calc(25% - 10rem);
      margin: 0 5rem 2.5rem;
      position: relative;
      z-index: 0;
      opacity: 0;
      .linkwrap{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        a{
          display: block; 
          width: 100%;
          height: 100%;
         
        }
      }
      // animation: mymove .3s ;
      &.imgloaded {
        opacity: 1;
        transition: opacity 0.3s ease-in-out 0.3s;
      }
      cursor: pointer;
      .all-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        &.loaded {
          display: none;
        }
      }
      .auto-height {
        display: block;
        width: 100%;
        height: 0;
        padding-bottom: 133%;
        background: center no-repeat #ffffff;
        background-size: contain;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .product-sign {
          position: absolute;
          z-index: 9;
          top: 1rem;
          right: 1rem;
          z-index: 1;
          // display: none;
          color:rgba(211,211,211,1);
          font-size: 1.1rem;
          text-align: right;
          line-height: 1.2;
          cursor: pointer;
          text-transform: initial;
        }

        .covers {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .over-img {
          // opacity: 1;
          &.base-img {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transition: opacity 0.5s;
          }
        }
        .img {
          max-width: 100%;
          vertical-align: middle;
        }
      }

      .other-color {
        position: absolute;
        // bottom: 5.3rem;
        bottom: 0;
        background: white;
        width: 100%;
        height: 5.8rem;
        display: flex;
        font-size: 1.2rem;
        color: #5c5d5f;
        align-items: center;
        z-index: 1;
        border-bottom: 0.1rem solid #5c5d5f;
        opacity: 0;
        transition: opacity 0.5s;
        .colorstext {
        }
        .colors {
          margin-left: auto;
        }
        .color-item {
          display: inline-block;
          margin-right: 0.5rem;
          background: #8e8f8b;
          border: 0.1rem solid #d8d8d8;
          width: 1.4rem;
          height: 1.4rem;
          box-sizing: border-box;
          &:nth-last-of-type(1) {
            margin-right: 0rem;
          }
          .colorpop{
            height: 20px;
            line-height: 20px;
            padding:0 10px;
            background: #f2f2f2;
            position: absolute;
            color: #333;
            font-size: 14px;
            z-index: 1000;
            display: none;
          }
          &:hover .colorpop{
            display: block;
            top:-30px;
            left:-15px;
          }

          .color {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .save-btn {
        position: absolute;
        top: -1.4rem;
        left: calc(100% - 2.5rem);
        min-width: 2.5rem;
        height: 3.9rem;
        z-index: 2;
        border: 0.1rem solid #fff;
        opacity: 0;
        transition: opacity 0.5s;
        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: -1;
          border-width: 0 2.5rem 2.5rem 0;
          border-style: solid;
          border-color: transparent #fff transparent transparent;
        }
        .btns {
          min-width: 7rem;
          min-height: 2.4rem;
          max-width: 8.5rem;
          height: 100%;
          overflow: hidden;
          padding: 0 0 0 2.4rem;
          opacity: 0;
          color: #969696;
          font-size: 1.2rem;
          text-align: left;
          transition: opacity 0.5s;
          display: inline-block;
          vertical-align: middle;
          border: none;
          background: 0 0;
          border-radius: 0;
          font-size: 0.9rem;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          cursor: pointer;
          -webkit-appearance: none;
        }
      }
      .show-save {
        opacity: 1 !important;
      }

      .goods-name {
        padding-top: 1.5rem;
        color: #959595;
        font-family: ArialNarrow, sans-serif;
        font-size: 1.3rem;
        line-height: 1.38;
        &:hover {
          color: #959595;
        }
        .product-sign-mb {
         // display: none;
        }
        .name {
          line-height: 1.33;
          letter-spacing: 0.055rem;
          text-transform: initial;
        }
        .currprice {
        }
        .originprice {
          text-decoration: line-through;
        }
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .good-container {
    .good-banner {
      width: calc(100% - 4rem);
      margin: 0 2rem 1rem;
    }
    .goods-list .goods-item {
      // .goods-list
      width: calc(33.33333% - 4rem);
      margin: 0 2rem 1rem;
      .save-btn {
        display: none;
      }
      .goods-name {
        padding-top: 2rem;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .pc{
    display:none!important;
  }
  .mob{
    display:block!important;
  }
  .good-container {
    &.fitPage {
      padding-top: 0;
    }
    .product-sign {
      // display: none;
    }
    .good-banner {
      width: calc(100% - 2rem);
      margin: 1rem;
    }

    .goods-list .goods-item {
      // .goods-list
      width: calc(50% - 2rem) !important;
      margin: 1rem !important;
      .goods-name {
        font-size: 1.2rem;
        .product-sign-mb {
          display: block;
        }
      }
      .other-color {
        display: block;
        .flex{
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
         
        }
      }
    }
  }
}
@keyframes mymove {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/Goods.vue